export default __webpack_public_path__ + "static/media/test2.a5813457.png";